import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UserDTO } from '../user/user.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageEvent } from '@angular/material/paginator';
import { Role } from '../user/role.model';
import { Department } from '../user/department.model';
import { Observable, tap, catchError, of } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import type { HttpErrorResponse } from '@angular/common/http';
import { MultiSelectSearch } from '../../helper/MultiSelectSearch';
import { IdName } from '../../dtos/IdName';
import { RoleEnum, RoleNameEnum } from '../../enums/role.enum';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
  standalone: false
})

export class UserListComponent implements OnInit {

  displayedColumns: string[] = [
  'select',
  'firstName','lastName','userName','contact',
  'email','department','employeeCode','joiningDate',
  'birthDate','role','employeeType','teamleads','actions'
];

teamleadDisplayedColumns: string[] = [
  'select',
  'firstName','lastName','userName','contact',
  'email','department','employeeCode','joiningDate',
  'birthDate','role','employeeType','teamleads'
];
  userData: UserDTO[] = [];
  usersForFilter: IdName[] = [];
  totalUsersCount!: number;
  pageSize: number = 10;
  currentPage: number = 1;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  roles: Role[] = [];
  departments: Department[] = [];
  teamleads: IdName[] = [];
  selectedRole: string =  '';
  selectedUsers: number[] = [];
  bulkEditPopupOpen: boolean = false;
  bulkEditForm!: FormGroup;
  filteredTeamleads: IdName[] = [];
  myUser?: UserDTO;
  employeeTypes: { id: number, type: string }[] = [
    // { id: 0, type: 'ADMIN' },
    { id: 1, type: 'EMPLOYEE' },
    { id: 2, type: 'MERIL CONSULTANT' },
    { id: 3, type: 'PRIME CONSULTANT' },
    { id: 4, type: 'EXTERNAL'}
  ];

  

  usersJsonData:any
  filterForm: FormGroup;
  isTeamlead: boolean = false;
  isAdmin: boolean = false;
  isDepartmentAdmin: boolean = false;

  userSearch: MultiSelectSearch<IdName>;
  departmentSearch: MultiSelectSearch<IdName>;
  roleSearch: MultiSelectSearch<IdName>;
  employeeTypeSearch!: MultiSelectSearch<IdName>;
  teamleadSearch!: MultiSelectSearch<IdName>;

  roleNameEnum: typeof RoleNameEnum = RoleNameEnum;
  constructor(
  private userService: UserService,
  private snackBar: MatSnackBar,
  private formBuilder: FormBuilder
) {

  this.filterForm = this.formBuilder.group({
    userIds: [[]],
    departmentIds: [[]],
    roleIds: [[]],
    employeeTypeIds: [[]],
    teamleadIds: [[]]
  });

  this.bulkEditForm = this.formBuilder.group({
    roleId: [''],
    employeeTypeId: [''],
    teamleads: [[]]
  });

  const employeeTypesList: IdName[] = this.employeeTypes.map(e => ({
    id: e.id,
    name: e.type
  }));

  this.userSearch = new MultiSelectSearch<IdName>(
    this.filterForm.get('userIds') as FormControl,
    []
  );

  this.departmentSearch = new MultiSelectSearch<IdName>(
    this.filterForm.get('departmentIds') as FormControl,
    []
  );

  this.roleSearch = new MultiSelectSearch<IdName>(
    this.filterForm.get('roleIds') as FormControl,
    []
  );

 this.employeeTypeSearch = new MultiSelectSearch<IdName>(
    this.filterForm.get('employeeTypeIds') as FormControl,
    []
);
    this.employeeTypeSearch.setOptions(employeeTypesList);
  this.teamleadSearch = new MultiSelectSearch<IdName>(
    this.filterForm.get('teamleadIds') as FormControl,
    []
  );
}
  ngOnInit(): void {
    this.getStorageData()
    // Fetch roles, departments, and users only on component initialization
    this.getRoles().subscribe(() => {
      this.getDepartments().subscribe(() => {
        this.getAllUsers(this.currentPage, this.pageSize);
        this.fetchFilteredTeamleads(this.usersJsonData.departmentId);
      });
    });
    // this.fetchTeamleads(this.myUser?.id);
    this.getAllUserForFilter();
  }

  getStorageData(){
    let user:any = sessionStorage.getItem("userData")
    this.usersJsonData = JSON.parse(user)
    this.isAdmin = this.usersJsonData.roleId == RoleEnum.ADMIN;
    this.isTeamlead = this.usersJsonData.roleId == RoleEnum.TEAMLEAD;
    this.isDepartmentAdmin = this.usersJsonData.roleId == RoleEnum.DEPARTMENT_ADMIN;
  }

  getRoles(): Observable<Role[]> {
    return this.userService.getRoles().pipe(
      tap((roles: Role[]) => {
        this.roles = roles; // assign the roles array to this.roles
        this.roleSearch.setOptions(this.roles.map((r: Role) => ({id: r.id, name: r.role})));
      }),
      catchError((error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
        return of([]); // return an empty array if there's an error
      })
    );
  }

  getDepartments(): Observable<Department[]> {
    return this.userService.getDepartments().pipe(
      tap((departments: Department[]) => {
        this.departments = departments; // assign the departments array to this.departments
        this.departmentSearch.setOptions(this.departments.map((d: Department) => ({id: d.id, name: d.departmentName})));
      }),
      catchError((error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
        return of([]); // return an empty array if there's an error
      })
    );
  }

  onDepartmentChange(departmentId: number, element: any) {
    if (element.originalDepartmentId !== departmentId) {
      element.roleId = null; // Reset role
      element.teamleads = []; // Reset team leads
      element.originalDepartmentId = departmentId; // Update original department ID
      this.fetchFilteredTeamleads(departmentId);
    }
  }

  getAllUsers( pageNo: number, pageSize: number ): void {
    if(this.isDepartmentAdmin) {
      this.filterForm.get('departmentIds')?.setValue([this.usersJsonData.departmentId]);
    }
   const {
  userIds,
  departmentIds,
  roleIds,
  employeeTypeIds,
  teamleadIds
} = this.filterForm.value;
   this.userService.getAllUsers(
  this.usersJsonData.id,
  pageNo,
  pageSize,
  userIds,
  departmentIds,
  roleIds,
  employeeTypeIds,
  teamleadIds
).subscribe(
      (res: any) => {
        if (Array.isArray(res.responseObject.responseData)) {
          this.userData = res.responseObject.responseData.map((user: UserDTO) => ({
            ...user,
            role: this.getRoleName(user.roleId),
            department: this.getDepartmentName(user.departmentId),
            employeeType: this.getEmployeeTypeName(user.employeeTypeId),
            teamleads: user.teamleads ? user.teamleads.map((tl: IdName) => ({ id: tl.id, name: tl.name })) : []
          }));
          this.totalUsersCount = res.responseObject.totalCount; // Set the totalUsersCount property
        } else {
          this.snackBar.open('Error fetching users: Invalid response format', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  getAllUserForFilter(): void {
    this.userService.getMembers().subscribe(
      (res: any) => {
        this.usersForFilter = res.responseObject;
        this.usersForFilter = this.usersForFilter.filter(user => user.id !== this.usersJsonData.id);
        this.userSearch.setOptions(this.usersForFilter);
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
}

  fetchFilteredTeamleads(departmentId: number): void {
    if (departmentId) {
      this.userService.getTeamleadsByDepartment(departmentId).subscribe(
        (res: IdName[]) => {
         this.filteredTeamleads = res;
this.teamleadSearch.setOptions(res);
          // this.filteredTeamleads.splice(this.filteredTeamleads.findIndex(a => a.id === element.id) , 1);
        },
        (error: any) => {
          this.filteredTeamleads = [];
        }
      );
    } else {
      this.filteredTeamleads = [];
    }
  }

  getRoleName(roleId: number): string | undefined {
    if (!this.roles) {
      return undefined;
    }
    const role = this.roles.find(r => r.id === roleId);
    return role ? role.role : undefined;
  }

  getTeamleadNames(teamleads: IdName[] | undefined): string {
    return teamleads && teamleads.length
      ? teamleads.map(tl => tl.name).join(', ') // Convert to comma-separated names
      : 'N/A'; // Show 'N/A' if no team leads assigned
  }

  compareTeamlead(tl1: IdName, tl2: IdName): boolean {
    return tl1 && tl2 ? tl1.id === tl2.id : tl1 === tl2;
  }

  getDepartmentName(departmentId: number): string | undefined {
    if (!this.departments) {
      return undefined;
    }
    const department = this.departments.find(d => d.id === departmentId);
    return department ? department.departmentName : undefined;
  }

  getEmployeeTypeName(employeeTypeId: number): string | undefined {
    if (!this.employeeTypes) {
      return undefined;
    }
    const employeeType = this.employeeTypes.find(et => et.id === employeeTypeId);
    return employeeType? employeeType.type : undefined;
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.getAllUsers(this.currentPage, this.pageSize);
  }

  editUser(element: any): void {
    element.editing = true;
    element.originalDepartmentId = element.departmentId;
    // this.fetchTeamleads(element.id); // Pass the user's ID
    this.fetchFilteredTeamleads(element.departmentId);
  }

  saveUser(element: any): void {
    const userData = { ...element };

    userData.roleId = element.roleId != null ? Number(element.roleId) : null;
    userData.departmentId = element.departmentId ? Number(element.departmentId) : null;
    userData.employeeTypeId = element.employeeTypeId ? Number(element.employeeTypeId) : null;
    delete userData.role;
    delete userData.department;
    delete userData.employeeType;
    delete userData.teamleadIds;
    delete userData.originalDepartmentId;

    userData.teamleads = element.teamleads ? element.teamleads.map((tl: IdName)=> ({ id: tl.id, name: tl.name })) : [];
    this.userService.update(userData).subscribe(
      (res: any) => {
        element.editing = false;

        // Update the role, department, and employeeType properties of the element object
        const roleName = this.getRoleName(userData.roleId);
        const departmentName = this.getDepartmentName(userData.departmentId);
        const employeeTypeName = this.getEmployeeTypeName(userData.employeeTypeId);
        
        if (roleName !== undefined) {
          element.role = roleName;
        }
  
        if (departmentName !== undefined) {
          element.department = departmentName;
        }
  
        if (employeeTypeName !== undefined) {
          element.employeeType = employeeTypeName;
        }
  
        // Update the userData array
        const index = this.userData.findIndex(user => user.id === element.id);
        if (index !== -1) {
          this.userData[index].roleId = userData.roleId;
          element.role = this.roles?.find(r => r.id === userData.roleId)?.role ?? '';
          this.userData[index].departmentId = userData.departmentId;
          element.department = this.departments?.find(d => d.id === userData.departmentId)?.departmentName ?? '';
          this.userData[index].employeeTypeId = userData.employeeTypeId;
          element.employeeType = this.employeeTypes?.find(et => et.id === userData.employeeTypeId)?.type ?? '';
          this.userData[index].teamleads = userData.teamleads; // Update teamleads as objects
        }
        this.snackBar.open(res.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
        this.getAllUsers(this.currentPage, this.pageSize);
        // this.fetchTeamleads();
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  cancelEdit(element: any): void {
    element.editing = false;
    this.getAllUsers(this.currentPage,this.pageSize);
  }

  deleteUser(element: any): void {
    if (confirm(`Are you sure you want to delete user ${element.firstName} ${element.lastName}?`)) {
      this.userService.deleteById(element.id).subscribe(
        (res: any) => {
          // Pass the current page size to the getAllUsers method
          this.getAllUsers(this.currentPage, this.pageSize);
          this.snackBar.open(res.message, 'close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          })
        },
        (error: any) => {
          this.snackBar.open(error.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      );
    }
  }

  

  toggleUserStatus(element: any): void {
    const action = element.isDisabled ? 'enable' : 'disable';
    if (confirm(`Are you sure you want to ${action} the user ${element.firstName} ${element.lastName}?`)) {
    
      const newStatus = !element.isDisabled;

      this.userService.disabledById(element.id, newStatus).subscribe({
        next: (res: any) => {
          element.isDisabled = newStatus;  // ⬅️ Update local data for UI change
          this.snackBar.open(res.message, 'close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
          this.getAllUsers(this.currentPage, this.pageSize);
        },
        error: (err: HttpErrorResponse) => {
          this.snackBar.open(err.message, 'close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      });
    }
  }


  softDeleteUser(element : any) {
    const action = element.isDeleted ? '' : 'disable';
    if (confirm(`Are you sure you want to ${action} the user ${element.firstName} ${element.lastName}?`)) {
    
      const newStatus = !element.isDeleted;

      this.userService.softDeleteById(element.id, newStatus).subscribe({
        next: (res: any) => {
          element.isDeleted = newStatus;  // ⬅️ Update local data for UI change
          this.snackBar.open(res.message, 'close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
          this.getAllUsers(this.currentPage, this.pageSize);
        },
        error: (err: HttpErrorResponse) => {
          this.snackBar.open(err.message, 'close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      });
    }
  }

  resetUser(element:any){
    if (confirm(`Are you sure you want to reset user ${element.firstName} ${element.lastName}?`)) {
      this.userService.resetUserPassword(element.id).subscribe(
        (res:any) => {
          // Pass the current page size to the getAllUsers method
          // this.getAllUsers(this.currentPage, this.pageSize);
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        },
        (error: any) => {
          this.snackBar.open(error.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      );
    }
  }

  onFilter(): void {
    this.currentPage = 1
    this.pageSize = 10
    this.getAllUsers(this.currentPage, this.pageSize);
  }

  clearFilter() {
  this.filterForm.reset({
    userIds: [],
    departmentIds: [],
    roleIds: [],
    employeeTypeIds: [],
    teamleadIds: []
  });

  this.onFilter();
}

toggleUserSelection(userId: number, event: any): void {
  if (event.checked) {
    if (!this.selectedUsers.includes(userId)) {
      this.selectedUsers.push(userId);
    }
  } else {
    this.selectedUsers = this.selectedUsers.filter(id => id !== userId);
  }
}

isAllSelected(): boolean {
  return this.userData.length > 0 &&
    this.userData.every(user => this.selectedUsers.includes(user.id!));
}

isSomeSelected(): boolean {
  return this.userData.some(user => this.selectedUsers.includes(user.id!))
    && !this.isAllSelected();
}

toggleSelectAll(event: any): void {
  if (event.checked) {
    this.userData.forEach(user => {
      if (!this.selectedUsers.includes(user.id!)) {
        this.selectedUsers.push(user.id!);
      }
    });
  } else {
    this.selectedUsers = this.selectedUsers.filter(
      id => !this.userData.some(user => user.id === id)
    );
  }
}

isUserSelected(id: number): boolean {
  return this.selectedUsers.includes(id);
}

openBulkEditPopup(): void {
  if (this.selectedUsers.length === 0) {
    this.snackBar.open('Please select at least one user', 'Close', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });
    return;
  }

  this.bulkEditPopupOpen = true;
}

closeBulkEditPopup(): void {
  this.bulkEditPopupOpen = false;

  this.bulkEditForm.reset({
    roleId: '',
    employeeTypeId: '',
    teamleads: []
  });
}

saveBulkEdit(): void {

  const { roleId, employeeTypeId, teamleads } = this.bulkEditForm.value;

  if (!roleId && !employeeTypeId && (!teamleads || teamleads.length === 0)) {
    this.snackBar.open('Please change at least one field before saving.', 'Close', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });
    return;
  }

  const selectedUsersData = this.userData.filter((u: any) =>
    this.selectedUsers.includes(u.id)
  );

  const allSameRole = roleId
    ? selectedUsersData.every((u: any) => u.roleId === roleId)
    : true;

  const allSameEmployeeType = employeeTypeId
    ? selectedUsersData.every((u: any) => u.employeeTypeId === employeeTypeId)
    : true;

  const allSameTeamleads = teamleads && teamleads.length > 0
    ? selectedUsersData.every((u: any) =>
        u.teamleads?.length === teamleads.length &&
        teamleads.every((tl: any) =>
          u.teamleads?.some((et: any) => et.id === tl.id)
        )
      )
    : true;

  const nothingChanged =
    (!roleId || allSameRole) &&
    (!employeeTypeId || allSameEmployeeType) &&
    ((!teamleads || teamleads.length === 0) || allSameTeamleads) &&
    (allSameRole && allSameEmployeeType && allSameTeamleads);

  if (nothingChanged) {
    this.snackBar.open(
      'No changes detected. Selected users already have the same values.',
      'Close',
      {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      }
    );
    return;
  }

  const confirmed = confirm('Are you sure you want to edit details?');
  if (!confirmed) {
    return; // 
  }

  const payload: any = {
    userIds: this.selectedUsers,
    roleId: roleId || null,
    employeeTypeId: employeeTypeId || null
  };

  if (teamleads && teamleads.length > 0) {
    payload.teamleads = teamleads;
  }

  this.userService.bulkUpdateUsers(payload).subscribe({
    next: (res: any) => {
      this.snackBar.open(res.message || 'Bulk update successful', 'Close', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      });
      this.getAllUsers(this.currentPage, this.pageSize);
      this.selectedUsers = [];
      this.closeBulkEditPopup();
    },
    error: (err: any) => {
      this.snackBar.open(
        err?.error?.message || 'Bulk update failed',
        'Close',
        { duration: 3000 }
      );
    }
  });
}
  confirmBulkEdit(): void {
    const confirmed = confirm('Are you sure you want to edit details?');
    if (confirmed) {
      this.saveBulkEdit();

    }
  }
}
